const FormItemSwitcher = props => {

    const type = props.type;
    const size = props.size;
    const errorStatus = props.error ? props.error : '&nbsp;';
    const errorType = props.error;

    const errorSection = `  <div class="error-section">
        <span>error</span>
    </div>
    <div class="success-section">
        <span>success</span>
    </div>`


    switch (type) {
        case 'text':
        case 'password':
        case 'email':
        case 'date':
        case 'datetime-local':
        case 'time':
        case 'week':
        case 'month':
        case 'file':
        case 'number':
        case 'search':
        case 'tel':
        case 'url':
        case 'range':
        case 'color':
            return `<div class="form-item ${size} ${errorType}">
    <label>${type}</label>
    <input type="${type}" />
    ${errorStatus && errorSection}
</div>`

        case 'textarea':
            return `<div class="form-item ${size} ${errorType}">
    <label>${type}</label>
    <textarea rows="10"></textarea>
    ${errorStatus && errorSection}
</div>`

        case 'select':
            return `<div class="form-item ${size} ${errorType}">
    <label>${type}</label>
    <select>
        <option value="1">one</option>
        <option value="2">two</option>
    </select>
    ${errorStatus && errorSection}
</div>`

        case 'checkbox':
            return `<div class="form-item ${size} ${errorType}">
    <div class="check-box">
        <input type="checkbox" />
        <label>${type}</label>
        ${errorStatus && errorSection}
    </div>
</div>`

        case 'radio':
            return `<div class="form-item ${size} ${errorType}">
    <label>${type}</label>
    <div class="radio-group">
        <div class="radio-item">
            <input type="radio" name="gender" value="male" />
            <label>Male</label>
        </div>
        <div class="radio-item">
            <input type="radio" name="gender" value="female" />
            <label>Female</label>
        </div>
    </div>
    ${errorStatus && errorSection}
</div>`
        default:
            return `<div class="form-item md">
    <label>text</label>
    <input type="text" />
    ${errorStatus && errorSection}
</div>`
    }

}

export default FormItemSwitcher